import { render, staticRenderFns } from "./ResetSystemUserPwd.vue?vue&type=template&id=72044324"
import script from "./ResetSystemUserPwd.vue?vue&type=script&lang=js"
export * from "./ResetSystemUserPwd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports